// Only factories registered here can cross the process boundary. Arbitrary
// callback policies remain on their existing executor.
const descriptors = new WeakMap();
export function describeVerifier(fn, descriptor) {
  descriptors.set(fn, structuredClone(descriptor));
  return fn;
}
export function serializeVerification(config) {
  if (!config) return { value: null };
  if (config.triage) return { reason: 'triagem com callback exige o executor atual' };
  const verifiers = {};
  for (const [name, fn] of Object.entries(config.verifiers || {})) {
    const descriptor = descriptors.get(fn);
    if (!descriptor) return { reason: `verificador ${name} exige o executor atual` };
    verifiers[name] = structuredClone(descriptor);
  }
  return { value: { verifiers, triage: null } };
}
